<template>
  <div class="zmanim-logo__container">
    <zmanim-clock v-if="showImage && live" :seconds="seconds" />
    <img
      v-else-if="showImage"
      class="zmanim-logo__static"
      src="@/assets/logo@3x.png"
    />
    <span v-if="showText" class="zmanim-logo__label">
      Ultimate Zmanim
    </span>
  </div>
</template>

<script>
import ZmanimClock from './ZmanimClock'

export default {
  name: 'ZmanimLogo',
  components: {
    ZmanimClock
  },
  props: {
    showText: {
      type: Boolean,
      default: true
    },
    showImage: {
      type: Boolean,
      default: true
    },
    live: {
      type: Boolean,
      default: false
    },
    seconds: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.zmanim-logo__container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: stretch;
  align-items: center;
  flex-shrink: 0;
  flex-grow: 0;
  padding: 0;
  margin: 0;
  height: 100%;
}

.zmanim-logo__static {
  display: flex;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: center;
  width: 5.63rem;
  height: 5.63rem;
}

.zmanim-logo__label {
  font-family: "Avenir-Heavy";
  font-size: 2.25rem;
  color: #ff8511;
  letter-spacing: 0;
  height: 3.13rem;
  align-self: center;
  flex-shrink: 0;
  flex-grow: 1;
}
</style>
